export * from './header-page.view';